import {Record, Map} from 'immutable';

import {
  STORE_ACTIVITIES,
  UPDATE_ACTIVITY,
  DELETE_ACTIVITY
} from './actions';

export const Activity = Record({
  id: null,
  actor: null,
  type: '',
  object: {}
});

export const initialState = Map({
  byId: Map()
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case STORE_ACTIVITIES: {
      const activities = {};

      action.payload.activities.forEach((a) => {
        activities[a.id] = new Activity(a);
      });

      return state.mergeIn(['byId'], activities);
    }

    case UPDATE_ACTIVITY: {
      const {activity} = action.payload;

      return state.mergeDeepIn(['byId', activity.id], activity);
    }

    case DELETE_ACTIVITY: {
      const {activity} = action.payload;

      return state.setIn(['byId', activity.id], activity);
    }
    default:
      return state;
  }
}
